// src/encounter/lib/wrap-up-invoice-gate.ts
// The wrap-up INVOICE gates, as pure functions so the permission matrix is testable without
// mounting the 4,700-line encounter shell.
//
// Flutter gates the whole invoice block on the Show_Billing_Summary VIEW permission AND !isNurse
// (wrap_up_billing_screen.dart:680-686), scoped to the wrap-up step. The Pending orders list
// (PROD-2594) uses the SAME gate for visibility, and — because there is no separate billing edit
// permission (add / remove service are gated only by this and an invoice id) — the same gate plus
// the server's Draft-only `canEdit` for its actions. Do not add a new permission here.
//
// Andrew, 9 Oct 2026 (PROD-2976): exact Flutter parity for nurses and doctors. The nurse exception
// that #616 added is reverted; keep `!isNurse` here.
import { evaluatePermissions } from '@/auth/permission-gate';

export interface WrapUpInvoiceGateInput {
  /** The started encounter shell is showing (the wrap-up reads are scoped to it). */
  wrapActive: boolean;
  isNurse: boolean;
  systemPermissions: Parameters<typeof evaluatePermissions>[0];
}

/** The invoice block — and the Pending orders list — are visible. */
export function canSeeWrapUpInvoice({ wrapActive, isNurse, systemPermissions }: WrapUpInvoiceGateInput): boolean {
  return wrapActive && !isNurse && evaluatePermissions(systemPermissions, ['Show_Billing_Summary'], { view: true });
}

/** Add / Dismiss / Restore on a pending order: the invoice gate, an invoice, and a Draft (`canEdit`). */
export function canActOnPendingOrders(
  canSeeInvoice: boolean,
  invoiceId: string | null | undefined,
  ordersCanEdit: boolean | undefined,
): boolean {
  return canSeeInvoice && !!invoiceId && ordersCanEdit === true;
}
